// Renders CMS rule text line by line (split on "\n" or <br>), keeping inline HTML (<u>, <b>...).
// Lines starting with a marker ("• ", "- ", "* ", "1. ", "1) ") get a hanging indent so wrapped text aligns.
const MARKER_REGEX = /^\s*(•|-|\*|\d+[.)])\s+/;

export default function RuleContent({ content = "", className = "" }) {
	const lines = content.split(/\r?\n|<br\s*\/?>/i);

	return (
		<div className={className}>
			{lines.map((line, index) => {
				if (!line.trim()) {
					return <div key={index} className="h-[1em]" />;
				}

				const match = line.match(MARKER_REGEX);
				if (match) {
					return (
						<div key={index} className="flex items-start gap-2">
							<span className="flex-shrink-0">{match[1]}</span>
							<span
								className="flex-1 min-w-0 wrap-break-word"
								dangerouslySetInnerHTML={{ __html: line.slice(match[0].length) }}
							/>
						</div>
					);
				}

				return (
					<div
						key={index}
						className="wrap-break-word"
						dangerouslySetInnerHTML={{ __html: line }}
					/>
				);
			})}
		</div>
	);
}
